import { render, staticRenderFns } from "./TaskNodeConfig.vue?vue&type=template&id=02353a2e&scoped=true"
import script from "./TaskNodeConfig.vue?vue&type=script&lang=js"
export * from "./TaskNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskNodeConfig.vue?vue&type=style&index=0&id=02353a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02353a2e",
  null
  
)

export default component.exports